import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { use as _$use } from "solid-js/web";
import { spread as _$spread } from "solid-js/web";
import { mergeProps as _$mergeProps } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=tzr-error>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=tzr-notice>`),
  _tmpl$3 = /*#__PURE__*/_$template(`<button type=button class="tzr-btn primary"> →`),
  _tmpl$4 = /*#__PURE__*/_$template(`<div class=tzr-overlay><div class=tzr-window><header><span></span><span class=tzr-x>✕</span></header><div class=tzr-steps></div><main></main><footer><div><button type=button class="tzr-btn danger"></button><button type=button class=tzr-btn></button></div><div><button type=button class=tzr-btn>← `),
  _tmpl$5 = /*#__PURE__*/_$template(`<div class=tzr-step-tab><span></span><b>`),
  _tmpl$6 = /*#__PURE__*/_$template(`<div class=slot-missing>—`),
  _tmpl$7 = /*#__PURE__*/_$template(`<dl class=tzr-kv><dt></dt><dd> <span>`),
  _tmpl$8 = /*#__PURE__*/_$template(`<label class=tzr-field><span> <i class=req>*</i></span><select><option value>`),
  _tmpl$9 = /*#__PURE__*/_$template(`<div class="tzr-step tzr-step-files"><div class=tzr-dropzone><input type=file multiple style=display:none><div class=tzr-drop-icon>🗂</div><div></div><div class=tzr-slots></div></div><div class=tzr-detectbox><label class=tzr-field><span></span><select></select></label><h3></h3><div class=tzr-hint>`),
  _tmpl$0 = /*#__PURE__*/_$template(`<span class=tzr-slot-promote>`),
  _tmpl$1 = /*#__PURE__*/_$template(`<span class=tzr-slot-x>✕`),
  _tmpl$10 = /*#__PURE__*/_$template(`<div class="slot-ok slot-extra"> `),
  _tmpl$11 = /*#__PURE__*/_$template(`<option>`),
  _tmpl$12 = /*#__PURE__*/_$template(`<div class=tzr-hint>`),
  _tmpl$13 = /*#__PURE__*/_$template(`<dt>`),
  _tmpl$14 = /*#__PURE__*/_$template(`<dd>`),
  _tmpl$15 = /*#__PURE__*/_$template(`<div class=tzr-warnbox>⚠ `),
  _tmpl$16 = /*#__PURE__*/_$template(`<span> km/h (<!>)`),
  _tmpl$17 = /*#__PURE__*/_$template(`<div class=tzr-photo-waiting>`),
  _tmpl$18 = /*#__PURE__*/_$template(`<img class=tzr-lp-crop alt>`),
  _tmpl$19 = /*#__PURE__*/_$template(`<div class="tzr-step tzr-step-vehicle"><div class=tzr-photo><div class=tzr-strip><span></span><span></span></div><div class=tzr-frame><img alt><canvas class=tzr-lp-canvas></canvas></div></div><div class=tzr-side><div class=tzr-hint></div><div class=tzr-photo-selector></div><div class=tzr-hint></div><label class=tzr-field><span> <i class=req>*</i></span><input></label><label class=tzr-field><span> <i class=req>*</i></span><input type=number class=prefilled disabled></label><label class=tzr-field><span> <i class=req>*</i></span><select><option value></option></select></label><label class=tzr-field><span> <i class=req>*</i></span><input type=number class=prefilled disabled>`),
  _tmpl$20 = /*#__PURE__*/_$template(`<button type=button><img alt><span>`),
  _tmpl$21 = /*#__PURE__*/_$template(`<option> — `),
  _tmpl$22 = /*#__PURE__*/_$template(`<div class=tzr-row2><label class=tzr-field><span> <i class=req>*</i></span><input class=prefilled inputmode=decimal></label><label class=tzr-field><span> <i class=req>*</i></span><input class=prefilled inputmode=decimal>`),
  _tmpl$23 = /*#__PURE__*/_$template(`<label class=tzr-field><span></span><input inputmode=numeric>`),
  _tmpl$24 = /*#__PURE__*/_$template(`<div class="tzr-step tzr-step-violation"><div class=tzr-form-col><div class=tzr-field><span> <i class=req>*</i></span><div class=tzr-tiles></div></div><label class=tzr-field><span> <i class=req>*</i></span><input type=datetime-local step=1 class=prefilled></label><div class=tzr-row2><label class=tzr-field><span></span><input class=prefilled></label></div><div class=tzr-hint>`),
  _tmpl$25 = /*#__PURE__*/_$template(`<div class=tzr-tile>`),
  _tmpl$26 = /*#__PURE__*/_$template(`<div class="tzr-step tzr-step-location"><div class=tzr-map><div class=tzr-map-coords>, </div></div><div class=tzr-side><label class=tzr-field><span> <i class=req>*</i></span><input></label><div class=tzr-field><span> <i class=req>*</i></span><div class=tzr-tiles></div></div><div class=tzr-row2><label class=tzr-field><span></span><input class=prefilled inputmode=decimal></label><label class=tzr-field><span></span><input class=prefilled inputmode=decimal></label></div><div class=tzr-hint>`),
  _tmpl$27 = /*#__PURE__*/_$template(`<div class="tzr-tile small">`),
  _tmpl$28 = /*#__PURE__*/_$template(`<dl class="tzr-kv tzr-geocode"><dt></dt><dd> <span class=tzr-code></span></dd><dt></dt><dd> <span class=tzr-code></span></dd><dt></dt><dd> <span class=tzr-code>`),
  _tmpl$29 = /*#__PURE__*/_$template(`<img alt>`),
  _tmpl$30 = /*#__PURE__*/_$template(`<div class="tzr-step tzr-step-summary"><div class="tzr-photo summary"></div><div class="tzr-side grow"><dl class="tzr-kv summary"></dl><div class=tzr-files-summary><b></b></div><div class=tzr-warnbox>⚠ <!>: </div><div class=tzr-sendbox><div><b></b><br><span class=tzr-hint></span></div><button type=button class="tzr-btn primary">`),
  _tmpl$31 = /*#__PURE__*/_$template(`<span>📄 <i>`);
/**
 * The five-step import wizard (design source: tmp/tzrecords-wizard-mock.html):
 * files → vehicle (plate region) → violation → location (map + geocode) → summary.
 * All state lives in the module store (`store.wizard`); the module class owns the
 * business logic (import/save/confirm), these components only render and dispatch.
 */

import { For, Show, onMount, createEffect } from 'solid-js';
import { useWorkflow } from 'mmodSolidWorkflow';
import { fmtDt, usToLocalInput, localInputToUs } from 'mmodSolidModule/datetime';
import { WIZARD_STEPS, VIOLATION_TYPES, MEASUREMENT_CONTEXTS, LP_COUNTRIES } from './constants';
import { SkMapPicker, useDropzone } from './components';
export function Wizard() {
  const {
    store,
    module: m,
    t,
    tr
  } = useWorkflow();
  const w = () => store.wizard;
  const step = () => w().step;
  const last = () => step() === WIZARD_STEPS.length - 1;
  return (() => {
    var _el$ = _tmpl$4(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.firstChild,
      _el$5 = _el$4.nextSibling,
      _el$6 = _el$3.nextSibling,
      _el$9 = _el$6.nextSibling,
      _el$0 = _el$9.nextSibling,
      _el$1 = _el$0.firstChild,
      _el$10 = _el$1.firstChild,
      _el$11 = _el$10.nextSibling,
      _el$12 = _el$1.nextSibling,
      _el$13 = _el$12.firstChild,
      _el$14 = _el$13.firstChild;
    _$insert(_el$4, () => tr('wizard.Title'));
    _el$5.$$click = () => m.closeWizard();
    _$insert(_el$6, _$createComponent(For, {
      each: WIZARD_STEPS,
      children: (key, index) => (() => {
        var _el$17 = _tmpl$5(),
          _el$18 = _el$17.firstChild,
          _el$19 = _el$18.nextSibling;
        _el$17.$$click = () => m.showStep(index());
        _$insert(_el$18, () => index() + 1);
        _$insert(_el$19, () => tr(`wizard.step.${key}`));
        _$effect(_p$ => {
          var _v$3 = !!(step() === index()),
            _v$4 = !!(index() < step());
          _v$3 !== _p$.e && _el$17.classList.toggle("active", _p$.e = _v$3);
          _v$4 !== _p$.t && _el$17.classList.toggle("done", _p$.t = _v$4);
          return _p$;
        }, {
          e: undefined,
          t: undefined
        });
        return _el$17;
      })()
    }));
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return w().error;
      },
      get children() {
        var _el$7 = _tmpl$();
        _$insert(_el$7, () => w().error);
        return _el$7;
      }
    }), _el$9);
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return w().notice;
      },
      get children() {
        var _el$8 = _tmpl$2();
        _$insert(_el$8, () => w().notice);
        return _el$8;
      }
    }), _el$9);
    _$insert(_el$9, _$createComponent(Show, {
      get when() {
        return step() === 0;
      },
      get children() {
        return _$createComponent(StepFiles, {});
      }
    }), null);
    _$insert(_el$9, _$createComponent(Show, {
      get when() {
        return step() === 1;
      },
      get children() {
        return _$createComponent(StepVehicle, {});
      }
    }), null);
    _$insert(_el$9, _$createComponent(Show, {
      get when() {
        return step() === 2;
      },
      get children() {
        return _$createComponent(StepViolation, {});
      }
    }), null);
    _$insert(_el$9, _$createComponent(Show, {
      get when() {
        return step() === 3;
      },
      get children() {
        return _$createComponent(StepLocation, {});
      }
    }), null);
    _$insert(_el$9, _$createComponent(Show, {
      get when() {
        return step() === 4;
      },
      get children() {
        return _$createComponent(StepSummary, {});
      }
    }), null);
    _el$10.$$click = () => m.closeWizard();
    _$insert(_el$10, () => t('form.cancel'));
    _el$11.$$click = () => m.saveDraft(true);
    _$insert(_el$11, () => tr('wizard.SaveDraft'));
    _el$13.$$click = () => m.showStep(step() - 1);
    _$insert(_el$13, () => t('form.back'), null);
    _$insert(_el$12, _$createComponent(Show, {
      get when() {
        return !last();
      },
      get children() {
        var _el$15 = _tmpl$3(),
          _el$16 = _el$15.firstChild;
        _el$15.$$click = () => m.showStep(step() + 1);
        _$insert(_el$15, () => t('form.next'), _el$16);
        _$effect(() => _el$15.disabled = !m.stepGate(step()));
        return _el$15;
      }
    }), null);
    _$effect(_p$ => {
      var _v$ = !w().record || !!w().busy,
        _v$2 = step() === 0;
      _v$ !== _p$.e && (_el$11.disabled = _p$.e = _v$);
      _v$2 !== _p$.t && (_el$13.disabled = _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}

/** STEP 1 — files + detection panel. */
function StepFiles() {
  const {
    store,
    module: m,
    t,
    tr
  } = useWorkflow();
  const w = () => store.wizard;
  const record = () => w().record;
  let elPicker;
  const pick = () => elPicker === null || elPicker === void 0 ? void 0 : elPicker.click();
  const onPicked = () => {
    // snapshot first: FileList is LIVE — resetting value empties it under the async reader,
    // which is why picking the photo + txt together used to import only one of them
    const files = Array.from(elPicker.files);
    elPicker.value = '';
    m.takeFiles(files);
  };
  const drop = useDropzone(files => m.takeFiles(files));

  // One flat list in the existing dropzone: metadata, every JPEG and all other attachments.
  // Main-photo selection deliberately does not exist in this step.
  const listed_files = () => {
    var _record, _record5, _record6;
    const rows = [];
    if (w().files.meta_name || (_record = record()) !== null && _record !== void 0 && _record.meta_name) {
      var _record2;
      rows.push({
        name: w().files.meta_name || record().meta_name,
        icon: '📄',
        metadata: true,
        queued: !((_record2 = record()) !== null && _record2 !== void 0 && _record2.id)
      });
    }
    const photo_names = new Set();
    for (const photo of w().files.photos || []) {
      if (photo.name && !photo_names.has(photo.name)) {
        var _record3, _record4;
        photo_names.add(photo.name);
        rows.push({
          name: photo.name,
          icon: '📷',
          attached: !!((_record3 = record()) !== null && _record3 !== void 0 && _record3.id) && photo.name !== record().photo_name,
          queued: !((_record4 = record()) !== null && _record4 !== void 0 && _record4.id)
        });
      }
    }
    if ((_record5 = record()) !== null && _record5 !== void 0 && _record5.photo_name && !photo_names.has(record().photo_name)) {
      photo_names.add(record().photo_name);
      rows.push({
        name: record().photo_name,
        icon: '📷'
      });
    }
    const saved = !!((_record6 = record()) !== null && _record6 !== void 0 && _record6.id);
    const extras = saved ? (record().attachments || []).filter(file => file.mime !== 'image/jpeg') : [...(w().files.extras || [])];
    extras.sort((a, b) => a.name.localeCompare(b.name, undefined, {
      numeric: true
    }));
    for (const file of extras) {
      rows.push({
        name: file.name,
        icon: '📎',
        attached: saved,
        queued: !saved
      });
    }
    return rows;
  };
  const detect_rows = () => {
    const r = record();
    if (!r) return [];
    return [['device_type', r.device_type], ['event_dt', fmtDt(r.event_dt)], ['speed_kmh', r.speed_kmh != null ? `${r.speed_kmh} km/h` : null], ['speed_limit', r.speed_limit != null ? `${r.speed_limit} km/h` : null], ['employee_num', r.employee_num], ['gps_lat', r.gps_lat != null ? `${r.gps_lat}, ${r.gps_lon}` : null]].filter(([, value]) => value != null && value !== '');
  };
  return (() => {
    var _el$20 = _tmpl$9(),
      _el$21 = _el$20.firstChild,
      _el$22 = _el$21.firstChild,
      _el$23 = _el$22.nextSibling,
      _el$24 = _el$23.nextSibling,
      _el$25 = _el$24.nextSibling,
      _el$27 = _el$21.nextSibling,
      _el$28 = _el$27.firstChild,
      _el$29 = _el$28.firstChild,
      _el$30 = _el$29.nextSibling,
      _el$31 = _el$28.nextSibling,
      _el$42 = _el$31.nextSibling;
    _el$21.$$click = pick;
    _$spread(_el$21, _$mergeProps({
      get classList() {
        return {
          'has-files': !!(w().files.photo_name || w().files.meta_name),
          dragging: drop.dragging()
        };
      }
    }, () => drop.handlers), false, true);
    _el$22.addEventListener("change", onPicked);
    var _ref$ = elPicker;
    typeof _ref$ === "function" ? _$use(_ref$, _el$22) : elPicker = _el$22;
    _$insert(_el$25, _$createComponent(Show, {
      get when() {
        return listed_files().length === 0;
      },
      get children() {
        return _tmpl$6();
      }
    }), null);
    _$insert(_el$25, _$createComponent(For, {
      get each() {
        return listed_files();
      },
      children: file => (() => {
        var _el$43 = _tmpl$10(),
          _el$44 = _el$43.firstChild;
        _$insert(_el$43, () => file.icon, _el$44);
        _$insert(_el$43, () => file.name, null);
        _$insert(_el$43, () => file.queued ? ' …' : ' ✓', null);
        _$insert(_el$43, _$createComponent(Show, {
          get when() {
            return _$memo(() => !!file.queued)() && !record();
          },
          get children() {
            var _el$45 = _tmpl$0();
            _el$45.$$click = e => {
              e.stopPropagation();
              m.useAsMeta(file.name);
            };
            _$insert(_el$45, () => tr('wizard.UseAsMeta'));
            return _el$45;
          }
        }), null);
        _$insert(_el$43, _$createComponent(Show, {
          get when() {
            return file.attached || file.queued;
          },
          get children() {
            var _el$46 = _tmpl$1();
            _el$46.$$click = e => {
              e.stopPropagation();
              m.detachFile(file.name);
            };
            return _el$46;
          }
        }), null);
        return _el$43;
      })()
    }), null);
    _$insert(_el$29, () => tr('device_type'));
    _el$30.addEventListener("change", e => m.changeParserType(e.currentTarget.value));
    _$insert(_el$30, _$createComponent(For, {
      get each() {
        return m.config.device_types;
      },
      children: type => (() => {
        var _el$47 = _tmpl$11();
        _el$47.value = type;
        _$insert(_el$47, () => tr(`device_type.${type}`));
        return _el$47;
      })()
    }));
    _$insert(_el$31, () => tr('wizard.Detected'));
    _$insert(_el$27, _$createComponent(Show, {
      get when() {
        return record();
      },
      get fallback() {
        return (() => {
          var _el$48 = _tmpl$12();
          _$insert(_el$48, () => tr('wizard.WaitingForFiles'));
          return _el$48;
        })();
      },
      get children() {
        return [(() => {
          var _el$32 = _tmpl$7(),
            _el$33 = _el$32.firstChild,
            _el$34 = _el$33.nextSibling,
            _el$35 = _el$34.firstChild,
            _el$36 = _el$35.nextSibling;
          _$insert(_el$33, () => tr('device_id'));
          _$insert(_el$34, () => record().device_id || '—', _el$35);
          _$insert(_el$36, (() => {
            var _c$ = _$memo(() => !!record().device_id);
            return () => _c$() ? tr('wizard.InRegister') : tr('wizard.NotInRegister');
          })());
          _$insert(_el$32, _$createComponent(For, {
            get each() {
              return detect_rows();
            },
            children: ([key, value]) => [(() => {
              var _el$49 = _tmpl$13();
              _$insert(_el$49, () => tr(key));
              return _el$49;
            })(), (() => {
              var _el$50 = _tmpl$14();
              _$insert(_el$50, value);
              return _el$50;
            })()]
          }), null);
          _$effect(() => _$className(_el$36, `tzr-pill ${record().device_id ? 'ok' : 'warn'}`));
          return _el$32;
        })(), _$createComponent(For, {
          get each() {
            return record().parse_warnings || [];
          },
          children: warning => (() => {
            var _el$51 = _tmpl$15(),
              _el$52 = _el$51.firstChild;
            _$insert(_el$51, () => m.tx(warning), null);
            return _el$51;
          })()
        }), _$createComponent(Show, {
          get when() {
            return !record().device_id;
          },
          get children() {
            var _el$37 = _tmpl$8(),
              _el$38 = _el$37.firstChild,
              _el$39 = _el$38.firstChild,
              _el$40 = _el$38.nextSibling,
              _el$41 = _el$40.firstChild;
            _$insert(_el$38, () => tr('device_id'), _el$39);
            _el$40.addEventListener("change", e => m.setValue('device_id', e.currentTarget.value));
            _$insert(_el$40, _$createComponent(For, {
              get each() {
                return store.devices || [];
              },
              children: id => (() => {
                var _el$53 = _tmpl$11();
                _el$53.value = id;
                _$insert(_el$53, id);
                return _el$53;
              })()
            }), null);
            _$effect(() => _el$40.value = m.value('device_id'));
            return _el$37;
          }
        })];
      }
    }), _el$42);
    _$insert(_el$42, () => tr('wizard.DetectHint'));
    _$effect(() => _el$24.innerHTML = tr('import.Drop'));
    _$effect(() => _el$30.value = m.value('device_type') || m.config.device_types[0] || '');
    return _el$20;
  })();
}

/** STEP 2 — photo + license-plate region selector. */
function StepVehicle() {
  const {
    store,
    module: m,
    t,
    tr
  } = useWorkflow();
  const w = () => store.wizard;
  const record = () => w().record;
  const photos = () => w().files.photos || [];
  const selected_photo = () => photos().find(photo => photo.name === w().selected_photo_name);
  let elFrame, elCanvas;

  // adapted from the in-vehicle delict wizard: draw a rectangle on the full-resolution canvas
  const setupSelector = () => {
    let drawing = false;
    let startX, startY;
    const getXY = e => {
      var _e$touches, _e$changedTouches;
      const touch = ((_e$touches = e.touches) === null || _e$touches === void 0 ? void 0 : _e$touches[0]) || ((_e$changedTouches = e.changedTouches) === null || _e$changedTouches === void 0 ? void 0 : _e$changedTouches[0]);
      const clientX = touch ? touch.clientX : e.clientX;
      const clientY = touch ? touch.clientY : e.clientY;
      const rect = elCanvas.getBoundingClientRect();
      return {
        x: (clientX - rect.left) * (elCanvas.width / rect.width),
        y: (clientY - rect.top) * (elCanvas.height / rect.height)
      };
    };
    const draw = (x1, y1, x2, y2) => {
      const ctx = elCanvas.getContext('2d');
      ctx.clearRect(0, 0, elCanvas.width, elCanvas.height);
      ctx.strokeStyle = '#00e050';
      ctx.lineWidth = Math.max(2, Math.round(elCanvas.width / 400));
      ctx.strokeRect(Math.min(x1, x2), Math.min(y1, y2), Math.abs(x2 - x1), Math.abs(y2 - y1));
    };
    const onDown = e => {
      var _selected_photo;
      if (!((_selected_photo = selected_photo()) !== null && _selected_photo !== void 0 && _selected_photo.data_url)) return;
      const pos = getXY(e);
      startX = pos.x;
      startY = pos.y;
      drawing = true;
      e.preventDefault();
      m.setValue('lpcrop', '');
      m.setValue('lpjpeg', '');
      m.setStore('wizard', 'crop_preview', '');
      draw(startX, startY, pos.x, pos.y);
    };
    const onMove = e => {
      if (!drawing) return;
      const pos = getXY(e);
      draw(startX, startY, pos.x, pos.y);
      e.preventDefault();
    };
    const onUp = async e => {
      if (!drawing) return;
      drawing = false;
      const pos = getXY(e);
      const x = Math.max(0, Math.round(Math.min(startX, pos.x)));
      const y = Math.max(0, Math.round(Math.min(startY, pos.y)));
      const width = Math.min(elCanvas.width - x, Math.round(Math.abs(pos.x - startX)));
      const height = Math.min(elCanvas.height - y, Math.round(Math.abs(pos.y - startY)));

      // ignore tiny accidental clicks
      if (width < 5 || height < 5) {
        elCanvas.getContext('2d').clearRect(0, 0, elCanvas.width, elCanvas.height);
        return;
      }
      draw(startX, startY, pos.x, pos.y);
      const x2 = x + width;
      const y2 = y + height;
      const crop = await cropImageRegion(elFrame.src, x, y, x2, y2);
      m.setValue('lpcrop', JSON.stringify({
        x1: x,
        y1: y,
        x2,
        y2
      }));
      m.setValue('lpjpeg', crop);
      m.setStore('wizard', 'crop_preview', crop);
    };
    const cancel = () => {
      if (drawing) {
        drawing = false;
        elCanvas.getContext('2d').clearRect(0, 0, elCanvas.width, elCanvas.height);
      }
    };
    elCanvas.onmousedown = onDown;
    elCanvas.onmousemove = onMove;
    elCanvas.onmouseup = onUp;
    elCanvas.onmouseleave = cancel;
    elCanvas.ontouchstart = onDown;
    elCanvas.ontouchmove = onMove;
    elCanvas.ontouchend = onUp;
    elCanvas.ontouchcancel = cancel;
  };

  // the stored region belongs to the main photo it was drawn on - never draw it over
  // any other photo shown in the frame
  const crop_photo = () => {
    var _record7;
    return ((_record7 = record()) === null || _record7 === void 0 ? void 0 : _record7.photo_name) || w().files.photo_name || '';
  };

  /** Size the canvas to the photo's native resolution and redraw a stored region. Runs on
   *  img load — also when the photo arrives late from the full-record fetch (DRAFT resume). */
  const sizeCanvas = () => {
    if (!(elFrame !== null && elFrame !== void 0 && elFrame.naturalWidth)) return;
    elCanvas.width = elFrame.naturalWidth;
    elCanvas.height = elFrame.naturalHeight;
    if (w().selected_photo_name !== crop_photo()) return;
    const stored = m.value('lpcrop') ? _.attempt(JSON.parse, m.value('lpcrop')) : null;
    if (stored && !_.isError(stored)) {
      const ctx = elCanvas.getContext('2d');
      ctx.strokeStyle = '#00e050';
      ctx.lineWidth = Math.max(2, Math.round(elCanvas.width / 400));
      ctx.strokeRect(stored.x1, stored.y1, stored.x2 - stored.x1, stored.y2 - stored.y1);
    }
  };
  onMount(() => {
    setupSelector();
    if (elFrame.complete) sizeCanvas(); // cached image fires no load event
  });

  // keep the overlay in sync with the store, not only with img load events: an empty frame
  // fires no load event, and neither does switching to a photo with identical content (a
  // copied frame reuses the same data URL) - in both cases the canvas would keep the
  // previous photo's rectangle forever
  createEffect(() => {
    var _selected_photo2;
    void w().selected_photo_name;
    void m.value('lpcrop');
    if (!elCanvas) return;
    if (!((_selected_photo2 = selected_photo()) !== null && _selected_photo2 !== void 0 && _selected_photo2.data_url)) {
      elCanvas.getContext('2d').clearRect(0, 0, elCanvas.width, elCanvas.height);
      return;
    }
    if (elFrame !== null && elFrame !== void 0 && elFrame.complete) sizeCanvas(); // resizing wipes the canvas even at unchanged dimensions
  });
  return (() => {
    var _el$54 = _tmpl$19(),
      _el$55 = _el$54.firstChild,
      _el$56 = _el$55.firstChild,
      _el$57 = _el$56.firstChild,
      _el$58 = _el$57.nextSibling,
      _el$63 = _el$56.nextSibling,
      _el$64 = _el$63.firstChild,
      _el$65 = _el$64.nextSibling,
      _el$67 = _el$55.nextSibling,
      _el$68 = _el$67.firstChild,
      _el$69 = _el$68.nextSibling,
      _el$70 = _el$69.nextSibling,
      _el$72 = _el$70.nextSibling,
      _el$73 = _el$72.firstChild,
      _el$74 = _el$73.firstChild,
      _el$75 = _el$73.nextSibling,
      _el$76 = _el$72.nextSibling,
      _el$77 = _el$76.firstChild,
      _el$78 = _el$77.firstChild,
      _el$79 = _el$77.nextSibling,
      _el$80 = _el$76.nextSibling,
      _el$81 = _el$80.firstChild,
      _el$82 = _el$81.firstChild,
      _el$83 = _el$81.nextSibling,
      _el$84 = _el$83.firstChild,
      _el$85 = _el$80.nextSibling,
      _el$86 = _el$85.firstChild,
      _el$87 = _el$86.firstChild,
      _el$88 = _el$86.nextSibling;
    _$insert(_el$57, () => {
      var _record8;
      return (_record8 = record()) === null || _record8 === void 0 ? void 0 : _record8.device_id;
    });
    _$insert(_el$58, () => {
      var _record9;
      return fmtDt((_record9 = record()) === null || _record9 === void 0 ? void 0 : _record9.event_dt);
    });
    _$insert(_el$56, _$createComponent(Show, {
      get when() {
        var _record0;
        return ((_record0 = record()) === null || _record0 === void 0 ? void 0 : _record0.speed_kmh) != null;
      },
      get children() {
        var _el$59 = _tmpl$16(),
          _el$60 = _el$59.firstChild,
          _el$62 = _el$60.nextSibling,
          _el$61 = _el$62.nextSibling;
        _$insert(_el$59, () => record().speed_kmh, _el$60);
        _$insert(_el$59, () => {
          var _record$speed_limit;
          return (_record$speed_limit = record().speed_limit) !== null && _record$speed_limit !== void 0 ? _record$speed_limit : '—';
        }, _el$62);
        return _el$59;
      }
    }), null);
    _el$64.addEventListener("load", sizeCanvas);
    var _ref$2 = elFrame;
    typeof _ref$2 === "function" ? _$use(_ref$2, _el$64) : elFrame = _el$64;
    var _ref$3 = elCanvas;
    typeof _ref$3 === "function" ? _$use(_ref$3, _el$65) : elCanvas = _el$65;
    _$insert(_el$55, _$createComponent(Show, {
      get when() {
        return !selected_photo();
      },
      get children() {
        var _el$66 = _tmpl$17();
        _$insert(_el$66, () => tr('wizard.SelectMainPhoto'));
        return _el$66;
      }
    }), null);
    _$insert(_el$68, () => tr('wizard.SelectMainPhoto'));
    _$insert(_el$69, _$createComponent(For, {
      get each() {
        return photos();
      },
      children: photo => (() => {
        var _el$89 = _tmpl$20(),
          _el$90 = _el$89.firstChild,
          _el$91 = _el$90.nextSibling;
        _el$89.$$click = () => m.selectMainPhoto(photo.name);
        _$insert(_el$91, () => photo.name === w().selected_photo_name ? '★ ' : '', null);
        _$insert(_el$91, () => photo.name, null);
        _$effect(_p$ => {
          var _v$8 = !!(photo.name === w().selected_photo_name),
            _v$9 = !photo.data_url || !!w().busy,
            _v$0 = photo.name,
            _v$1 = photo.data_url;
          _v$8 !== _p$.e && _el$89.classList.toggle("selected", _p$.e = _v$8);
          _v$9 !== _p$.t && (_el$89.disabled = _p$.t = _v$9);
          _v$0 !== _p$.a && _$setAttribute(_el$89, "title", _p$.a = _v$0);
          _v$1 !== _p$.o && _$setAttribute(_el$90, "src", _p$.o = _v$1);
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined,
          o: undefined
        });
        return _el$89;
      })()
    }));
    _$insert(_el$67, _$createComponent(Show, {
      get when() {
        return w().crop_preview;
      },
      get children() {
        var _el$71 = _tmpl$18();
        _$effect(() => _$setAttribute(_el$71, "src", w().crop_preview));
        return _el$71;
      }
    }), _el$72);
    _$insert(_el$73, () => tr('lpnumber'), _el$74);
    _el$75.$$input = e => m.setValue('lpnumber', e.currentTarget.value.toUpperCase().replace(/[^A-Z0-9]/g, ''));
    _$insert(_el$77, () => tr('license_plate_number_confidence'), _el$78);
    _$insert(_el$81, () => tr('lpcountry'), _el$82);
    _el$83.addEventListener("change", e => m.setValue('lpcountry', e.currentTarget.value));
    _$insert(_el$83, _$createComponent(For, {
      each: LP_COUNTRIES,
      children: code => (() => {
        var _el$92 = _tmpl$21(),
          _el$93 = _el$92.firstChild;
        _el$92.value = code;
        _$insert(_el$92, code, _el$93);
        _$insert(_el$92, () => t(`country.${code}`), null);
        return _el$92;
      })()
    }), null);
    _$insert(_el$86, () => tr('country_code_confidence'), _el$87);
    _$effect(_p$ => {
      var _selected_photo3;
      var _v$5 = ((_selected_photo3 = selected_photo()) === null || _selected_photo3 === void 0 ? void 0 : _selected_photo3.data_url) || '',
        _v$6 = !m.value('lpcrop'),
        _v$7 = tr('wizard.DrawPlate');
      _v$5 !== _p$.e && _$setAttribute(_el$64, "src", _p$.e = _v$5);
      _v$6 !== _p$.t && _el$70.classList.toggle("missing", _p$.t = _v$6);
      _v$7 !== _p$.a && (_el$70.innerHTML = _p$.a = _v$7);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined
    });
    _$effect(() => _el$75.value = m.value('lpnumber'));
    _$effect(() => _el$79.value = m.value('license_plate_number_confidence'));
    _$effect(() => _el$83.value = m.value('lpcountry'));
    _$effect(() => _el$88.value = m.value('country_code_confidence'));
    return _el$54;
  })();
}
async function cropImageRegion(src, x1, y1, x2, y2) {
  const width = x2 - x1;
  const height = y2 - y1;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const img = new Image();
  img.src = src;
  await new Promise(resolve => {
    img.onload = resolve;
    if (img.complete) resolve();
  });
  canvas.getContext('2d').drawImage(img, x1, y1, width, height, 0, 0, width, height);
  return canvas.toDataURL('image/jpeg');
}

/** STEP 3 — violation type + times + speeds. */
function StepViolation() {
  const {
    module: m,
    tr
  } = useWorkflow();
  const type = () => m.value('type');
  return (() => {
    var _el$94 = _tmpl$24(),
      _el$95 = _el$94.firstChild,
      _el$96 = _el$95.firstChild,
      _el$97 = _el$96.firstChild,
      _el$98 = _el$97.firstChild,
      _el$99 = _el$97.nextSibling,
      _el$100 = _el$96.nextSibling,
      _el$101 = _el$100.firstChild,
      _el$102 = _el$101.firstChild,
      _el$103 = _el$101.nextSibling,
      _el$113 = _el$100.nextSibling,
      _el$117 = _el$113.firstChild,
      _el$118 = _el$117.firstChild,
      _el$119 = _el$118.nextSibling,
      _el$120 = _el$113.nextSibling;
    _$insert(_el$97, () => tr('type'), _el$98);
    _$insert(_el$99, _$createComponent(For, {
      each: VIOLATION_TYPES,
      children: key => (() => {
        var _el$121 = _tmpl$25();
        _el$121.$$click = () => m.setViolationType(key);
        _$insert(_el$121, () => tr(`violation.${key}`));
        _$effect(() => _el$121.classList.toggle("sel", !!(type() === key)));
        return _el$121;
      })()
    }));
    _$insert(_el$101, () => tr('event_dt'), _el$102);
    _el$103.addEventListener("change", e => m.setValue('event_dt', localInputToUs(e.currentTarget.value)));
    _$insert(_el$95, _$createComponent(Show, {
      get when() {
        return !type() || type() === 'SPD';
      },
      get children() {
        var _el$104 = _tmpl$22(),
          _el$105 = _el$104.firstChild,
          _el$106 = _el$105.firstChild,
          _el$107 = _el$106.firstChild,
          _el$108 = _el$106.nextSibling,
          _el$109 = _el$105.nextSibling,
          _el$110 = _el$109.firstChild,
          _el$111 = _el$110.firstChild,
          _el$112 = _el$110.nextSibling;
        _$insert(_el$106, () => tr('speed_kmh'), _el$107);
        _el$108.$$input = e => m.setValue('speed_kmh', e.currentTarget.value);
        _$insert(_el$110, () => tr('speed_limit'), _el$111);
        _el$112.$$input = e => m.setValue('speed_limit', e.currentTarget.value);
        _$effect(() => _el$108.value = m.value('speed_kmh'));
        _$effect(() => _el$112.value = m.value('speed_limit'));
        return _el$104;
      }
    }), _el$113);
    _$insert(_el$113, _$createComponent(Show, {
      get when() {
        return !type() || type() === 'SPD';
      },
      get children() {
        var _el$114 = _tmpl$23(),
          _el$115 = _el$114.firstChild,
          _el$116 = _el$115.nextSibling;
        _$insert(_el$115, () => tr('lane'));
        _el$116.$$input = e => m.setValue('lane', e.currentTarget.value);
        _$effect(() => _el$116.value = m.value('lane'));
        return _el$114;
      }
    }), _el$117);
    _$insert(_el$118, () => tr('employee_num'));
    _el$119.$$input = e => m.setValue('employee_num', e.currentTarget.value);
    _$insert(_el$120, () => tr('wizard.PrefilledHint'));
    _$effect(() => _el$103.value = usToLocalInput(m.value('event_dt')));
    _$effect(() => _el$119.value = m.value('employee_num'));
    return _el$94;
  })();
}

/** STEP 4 — location + measurement context. */
function StepLocation() {
  const {
    store,
    module: m,
    t,
    tr
  } = useWorkflow();

  // a position measured by the device is EVIDENCE — locked; manual placement (map click,
  // pin drag, typed coordinates) is only for devices whose metadata carries no GPS
  const gps_locked = () => {
    var _store$wizard;
    const record = (_store$wizard = store.wizard) === null || _store$wizard === void 0 ? void 0 : _store$wizard.record;
    return (record === null || record === void 0 ? void 0 : record.gps_lat) != null && (record === null || record === void 0 ? void 0 : record.gps_lon) != null && record.gps_lat !== '' && record.gps_lon !== '';
  };
  return (() => {
    var _el$122 = _tmpl$26(),
      _el$123 = _el$122.firstChild,
      _el$124 = _el$123.firstChild,
      _el$125 = _el$124.firstChild,
      _el$126 = _el$123.nextSibling,
      _el$127 = _el$126.firstChild,
      _el$128 = _el$127.firstChild,
      _el$129 = _el$128.firstChild,
      _el$130 = _el$128.nextSibling,
      _el$131 = _el$127.nextSibling,
      _el$132 = _el$131.firstChild,
      _el$133 = _el$132.firstChild,
      _el$134 = _el$132.nextSibling,
      _el$135 = _el$131.nextSibling,
      _el$136 = _el$135.firstChild,
      _el$137 = _el$136.firstChild,
      _el$138 = _el$137.nextSibling,
      _el$139 = _el$136.nextSibling,
      _el$140 = _el$139.firstChild,
      _el$141 = _el$140.nextSibling,
      _el$143 = _el$135.nextSibling;
    _$insert(_el$123, _$createComponent(SkMapPicker, {
      get lat() {
        return m.value('gps_lat');
      },
      get lon() {
        return m.value('gps_lon');
      },
      get map() {
        return m.config.map;
      },
      get locked() {
        return gps_locked();
      },
      onChange: (lat, lon) => {
        m.setValue('gps_lat', String(lat));
        m.setValue('gps_lon', String(lon));
        m.geocodePreview();
      }
    }), _el$124);
    _$insert(_el$124, () => m.value('gps_lat'), _el$125);
    _$insert(_el$124, () => m.value('gps_lon'), null);
    _$insert(_el$128, () => tr('locality'), _el$129);
    _el$130.$$input = e => m.setValue('locality', e.currentTarget.value);
    _$insert(_el$132, () => tr('context'), _el$133);
    _$insert(_el$134, _$createComponent(For, {
      each: MEASUREMENT_CONTEXTS,
      children: key => (() => {
        var _el$144 = _tmpl$27();
        _el$144.$$click = () => m.setValue('context', key);
        _$insert(_el$144, () => t(`delict.context.${key}`));
        _$effect(() => _el$144.classList.toggle("sel", !!(m.value('context') === key)));
        return _el$144;
      })()
    }));
    _$insert(_el$137, () => tr('gps_lat'));
    _el$138.addEventListener("change", () => m.geocodePreview());
    _el$138.$$input = e => m.setValue('gps_lat', e.currentTarget.value);
    _$insert(_el$140, () => tr('gps_lon'));
    _el$141.addEventListener("change", () => m.geocodePreview());
    _el$141.$$input = e => m.setValue('gps_lon', e.currentTarget.value);
    _$insert(_el$126, _$createComponent(GeocodePreview, {}), _el$143);
    _$insert(_el$126, _$createComponent(Show, {
      get when() {
        return gps_locked();
      },
      get children() {
        var _el$142 = _tmpl$12();
        _$insert(_el$142, () => tr('wizard.GpsLocked'));
        return _el$142;
      }
    }), _el$143);
    _$insert(_el$143, () => tr('wizard.GeocodeHint'));
    _$effect(_p$ => {
      var _v$10 = tr('wizard.LocalityPlaceholder'),
        _v$11 = gps_locked(),
        _v$12 = gps_locked();
      _v$10 !== _p$.e && _$setAttribute(_el$130, "placeholder", _p$.e = _v$10);
      _v$11 !== _p$.t && (_el$138.readOnly = _p$.t = _v$11);
      _v$12 !== _p$.a && (_el$141.readOnly = _p$.a = _v$12);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined
    });
    _$effect(() => _el$130.value = m.value('locality'));
    _$effect(() => _el$138.value = m.value('gps_lat'));
    _$effect(() => _el$141.value = m.value('gps_lon'));
    return _el$122;
  })();
}

/** Live territorial classification for the entered GPS (kraj/okres/obec + codes). */
function GeocodePreview() {
  const {
    store,
    tr
  } = useWorkflow();
  const geocode = () => {
    var _store$wizard2;
    return (_store$wizard2 = store.wizard) === null || _store$wizard2 === void 0 ? void 0 : _store$wizard2.geocode;
  };
  return _$createComponent(Show, {
    get when() {
      return geocode();
    },
    get children() {
      return _$createComponent(Show, {
        get when() {
          return !geocode().error;
        },
        get fallback() {
          return (() => {
            var _el$158 = _tmpl$15(),
              _el$159 = _el$158.firstChild;
            _$insert(_el$158, () => geocode().error, null);
            return _el$158;
          })();
        },
        get children() {
          var _el$145 = _tmpl$28(),
            _el$146 = _el$145.firstChild,
            _el$147 = _el$146.nextSibling,
            _el$148 = _el$147.firstChild,
            _el$149 = _el$148.nextSibling,
            _el$150 = _el$147.nextSibling,
            _el$151 = _el$150.nextSibling,
            _el$152 = _el$151.firstChild,
            _el$153 = _el$152.nextSibling,
            _el$154 = _el$151.nextSibling,
            _el$155 = _el$154.nextSibling,
            _el$156 = _el$155.firstChild,
            _el$157 = _el$156.nextSibling;
          _$insert(_el$146, () => tr('region_code'));
          _$insert(_el$147, () => geocode().region_name || '—', _el$148);
          _$insert(_el$149, () => geocode().region_code);
          _$insert(_el$150, () => tr('district_code'));
          _$insert(_el$151, () => geocode().district_name || '—', _el$152);
          _$insert(_el$153, () => geocode().district_code);
          _$insert(_el$154, () => tr('municipality_code'));
          _$insert(_el$155, () => geocode().municipality_name || '—', _el$156);
          _$insert(_el$157, () => geocode().municipality_code);
          return _el$145;
        }
      });
    }
  });
}

/** STEP 5 — summary + confirm & send. */
function StepSummary() {
  const {
    store,
    module: m,
    t,
    tr
  } = useWorkflow();
  const w = () => store.wizard;
  const record = () => w().record || {};

  // every step-3/4 field shows explicitly — a missing value renders as a dash, it must not
  // silently disappear from the confirmation summary
  const rows = () => {
    const v = key => m.value(key);
    const dash = value => value || '—';
    const result = [['device_id', `${v('device_id') || record().device_id || '—'} (${record().device_type || '—'})`], ['type', v('type') ? tr(`violation.${v('type')}`) : '—'], ['event_dt', v('event_dt') ? fmtDt(v('event_dt')) : '—'], v('type') === 'SPD' ? ['speed_kmh', v('speed_kmh') ? `${v('speed_kmh')} km/h` : '—'] : null, v('type') === 'SPD' ? ['speed_limit', v('speed_limit') ? `${v('speed_limit')} km/h` : '—'] : null, ['lpnumber', v('lpnumber') ? `${v('lpnumber')} (${dash(v('lpcountry'))})` : '—'], ['license_plate_number_confidence', dash(v('license_plate_number_confidence'))], ['country_code_confidence', dash(v('country_code_confidence'))], ['locality', dash(v('locality'))], ['context', v('context') ? t(`delict.context.${v('context')}`) : '—'], ['gps_lat', v('gps_lat') ? `${v('gps_lat')}, ${v('gps_lon')}` : '—'], v('type') === 'SPD' ? ['lane', dash(v('lane'))] : null, ['employee_num', dash(v('employee_num'))], ['passage_id', record().passage_id || null]];
    if (w().geocode && !w().geocode.error) {
      // the same territorial block the detail drawer shows: name + code per level
      const g = w().geocode;
      result.push(['region_code', `${g.region_name || '—'} ${g.region_code || ''}`.trim()]);
      result.push(['district_code', `${g.district_name || '—'} ${g.district_code || ''}`.trim()]);
      result.push(['municipality_code', `${g.municipality_name || '—'} ${g.municipality_code || ''}`.trim()]);
    }
    return result.filter(row => row && row[1] != null);
  };

  // the files that will enter the TM package: photo → media, metadata (+ attachments) → originData
  const files = () => [[tr('import.MainPhoto'), record().photo_name || w().files.photo_name], [tr('import.Metadata'), record().meta_name || w().files.meta_name], ...(record().attachments || []).map(file => [file.mime || '', file.name])].filter(([, name]) => name);
  const warnings = () => Array.isArray(record().parse_warnings) ? record().parse_warnings : [];
  return (() => {
    var _el$160 = _tmpl$30(),
      _el$161 = _el$160.firstChild,
      _el$163 = _el$161.nextSibling,
      _el$164 = _el$163.firstChild,
      _el$165 = _el$164.nextSibling,
      _el$166 = _el$165.firstChild,
      _el$167 = _el$165.nextSibling,
      _el$168 = _el$167.firstChild,
      _el$170 = _el$168.nextSibling,
      _el$169 = _el$170.nextSibling,
      _el$171 = _el$167.nextSibling,
      _el$172 = _el$171.firstChild,
      _el$173 = _el$172.firstChild,
      _el$174 = _el$173.nextSibling,
      _el$175 = _el$174.nextSibling,
      _el$176 = _el$172.nextSibling;
    _$insert(_el$161, _$createComponent(Show, {
      get when() {
        return record().jpeg2 || record().jpeg;
      },
      get children() {
        var _el$162 = _tmpl$29();
        _el$162.$$click = () => m.setStore('lightbox', record().jpeg || record().jpeg2);
        _$effect(() => _$setAttribute(_el$162, "src", record().jpeg2 || record().jpeg));
        return _el$162;
      }
    }));
    _$insert(_el$164, _$createComponent(For, {
      get each() {
        return rows();
      },
      children: ([key, value]) => [(() => {
        var _el$177 = _tmpl$13();
        _$insert(_el$177, () => tr(key));
        return _el$177;
      })(), (() => {
        var _el$178 = _tmpl$14();
        _$insert(_el$178, value);
        return _el$178;
      })()]
    }));
    _$insert(_el$166, () => tr('wizard.Files'));
    _$insert(_el$165, _$createComponent(For, {
      get each() {
        return files();
      },
      children: ([kind, name]) => (() => {
        var _el$179 = _tmpl$31(),
          _el$180 = _el$179.firstChild,
          _el$181 = _el$180.nextSibling;
        _$insert(_el$179, name, _el$181);
        _$insert(_el$181, kind);
        return _el$179;
      })()
    }), null);
    _$insert(_el$167, () => tr('wizard.ParserWarnings'), _el$170);
    _$insert(_el$167, (() => {
      var _c$2 = _$memo(() => !!warnings().length);
      return () => _c$2() ? warnings().map(warning => m.tx(warning)).join('; ') : tr('wizard.None');
    })(), null);
    _$insert(_el$173, () => tr('wizard.Complete'));
    _$insert(_el$175, () => tr('wizard.ConfirmHint'));
    _el$176.$$click = () => m.confirmSend();
    _$insert(_el$176, () => tr('wizard.ConfirmSend'));
    _$effect(() => _el$176.disabled = !m.allGatesPass() || !!w().busy);
    return _el$160;
  })();
}
_$delegateEvents(["click", "input"]);